module.exports = __webpack_public_path__ + "img/bookings.6ca7a1b2.webp";